import React from "react";

export const IntroInfo = () => {
  return (
    <>
      <p>
        Hello, I'm Abhinav Akhil, fullstack Web Engineer. I'm in love with
        opensource, communties and working on scalable software. I am up for
        freelancing projects, mentorships, workshops. <br />
        "I create software, that tell stories."
      </p>
    </>
  );
};
export const AboutInfo = () => {
  const style = {
    textDecoration: "underline",
    fontWeight: "800",
    color: "#232946",
  };
  return (
    <>
      <p>
        I am a Software Engineer, Who is passionate about building
        user-friendly, easy-to-use applications, that makes a difference to the
        lives of the people.
        <br />
        <br />I started with developing Web Apps and currently diving more into
        Backend development🔥.
        {/* <br />I also run NEWS media company{" "}
        <a
          href="https://www.eternalmac.com"
          target="_blank"
          style={style}
          rel="noreferrer"
        >
          Eternalmac.com
        </a>{" "}
        Where we post all tech news for techies. */}
        <br />
        <br /> I am an open source contributor and I love to take part in
        Hackathons 😅. Always there to help others and to clarify the doubts you
        have. Checkout my recent tweets{" "}
        <a
          href="https://twitter.com/akhil_abhinav"
          target="_blank"
          style={style}
          rel="noreferrer"
        >
          lets talk
        </a>{" "}
        , Definitely check those out.
        <br />
        <br />
        At last, Feel free to{" "}
        <a href="/contact" style={style}>
          Contact ME.
        </a>{" "}
        PS: I love discussing about space and the end-less possibility it
        holds🧑‍🚀.
      </p>
    </>
  );
};
